export default {
  defaultProps: {
    colorScheme: 'primary',
  },
  variants: {
    yesButton: {
      container: {
        px: 3,
        py: 1,
        boxShadow: 'base',
        borderRadius: 'base',
        border: '1px solid',
        borderColor: 'greys.100',
        transition: 'all 0.1s ease',
        _checked: {
          bg: 'signal.positive',
          color: 'white',
        },
      },
      control: {
        _checked: {
          borderWidth: '3.5px',
          borderColor: 'white',
          bg: 'transparent',
          _before: {
            bg: 'signal.positive',
          },
          _hover: {
            bg: 'signal.positive',
            borderColor: 'white',
          },
        },
      },
      label: {
        ml: 1,
        fontSize: 'xs',
      },
    },
    noButton: {
      container: {
        px: 3,
        py: 1,
        boxShadow: 'base',
        borderRadius: 'base',
        border: '1px solid',
        borderColor: 'greys.100',
        transition: 'all 0.1s ease',
        _checked: {
          bg: 'signal.negative',
          color: 'white',
        },
      },
      control: {
        _checked: {
          borderWidth: '3.5px',
          borderColor: 'white',
          bg: 'transparent',
          _before: {
            bg: 'signal.negative',
          },
          _hover: {
            bg: 'signal.negative',
            borderColor: 'white',
          },
        },
      },
      label: {
        ml: 1,
        fontSize: 'xs',
      },
    },
    notRelevantButton: {
      container: {
        py: 1,
      },
      label: {
        ml: 1,
        fontSize: 'xs',
        color: 'greys.400',
      },
    },
  },
}
